module.exports = __webpack_public_path__ + "media/images/sun_haze-238b23be9798cfe8498f2e74eb13ba2b.png";